import React from 'react';
import Select, { createFilter } from "react-select";
import { Button, Form } from "react-bootstrap";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../_metronic/_partials/controls/Card";
import Loader from "react-loader-spinner";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {
  getRequest,
  Uri_GetFacility,
  getRequestQry,
  Uri_GetResidentByFacilityId,
  getRequestById,
  URI_GetResidentWoundByResidentID,
  Uri_GetWoundDocumentationByWoundID
} from "../../General/api";
import {
  showSuccessAlertAutoClose,
  LogError,
  getInputStringDateUsingMoment2,
  showSuccessAlert,
  calculatePushScore
} from "../../General/common";
import uuid from 'node-uuid'
import moment from 'moment';
import { woundFilterType } from '../../General/wound-filter-type.enum';
import { documentationFilterType } from '../../General/documentation-filter.enum';

export default class WoundEvaluationReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formValidated: false,
      facilityList: [],
      facilitySelect: null,
      facilityForPDFName: null,
      facilityResidentList: [],
      residentSelect: null,
      residentWoundList: [],
      woundSelected: null,
      IsLoading: false,
      showReport: false,
      wound: {
        FacilityId: null,
        ResidentId: null,
        WoundId: null,
      },
      woundEvaluations: {
        residentName: '',
        facilityName: '',
        facilityAddress: '',
        room: '',
        physicianName: '',
        woundLocation: '',
        bodyRegionName: '',
        orientation: '',
        woundType: '',
        acquisition: '',
        woundEvaluationDetail: []
      }

    }
  }

  componentDidMount() {
    this.getAllFacility();
  }

  getAllFacility() {
    getRequest(Uri_GetFacility + "?isAssessmentView=1")
      .then((res) => {

        if (res.data.statusCode === 200) {
          if (res.data.result != null) {

            if (res.data.result.length > 0) {
              let facilityList = res.data.result.map(facility => (
                { value: facility.id, label: facility.facilityName }
              )).sort((a, b) => a.label.localeCompare(b.label));

              this.setState({ facilityList: facilityList, IsLoading: true })
            }
          }
        }
      }).catch((error) => {
        console.error(error);
        showSuccessAlertAutoClose('Sorry, an error has occurred.', 'warning', 'warning!', 3000)
      });
  }

  onFacilityChange = (facility) => {
    this.setState({
      facilityResidentList: [],
      residentWoundList: [],
      facilitySelect: facility,
      residentSelect: null,
      woundSelected: null,
    })

    if (facility) {
      getRequestQry(Uri_GetResidentByFacilityId, `?facilityId=${facility.value}&woundFilter=${woundFilterType.Both}`)
        .then((res) => {
          if (res.data.statusCode === 200 && res.data.result != null && res.data.result.length > 0) {
            const data = res.data.result;
            let optionTemplate = data.map((resident) => (
              { value: resident.key, label: resident.value }
            )).sort((a, b) => a.label.localeCompare(b.label));
            this.setState({ facilityResidentList: optionTemplate })
          }
        })
        .catch((error) => {
          console.log(error)
          showSuccessAlertAutoClose('Sorry, an error has occurred.', 'warning', 'warning!', 3000)
        });
    }
  }

  onResidentChange = (resident) => {
    this.setState({
      residentWoundList: [],
      residentSelect: resident,
      woundSelected: null
    })

    if (resident) {
      getRequestQry(URI_GetResidentWoundByResidentID, `?id=${resident.value}&isDocumentationOnly=${documentationFilterType.Both}`)
        .then((res) => {
          if (res.data.statusCode === 200 && res.data.result != null && res.data.result.length > 0) {
            let residentWoundList = res.data.result.map(element => (
              { value: element.wound.id, label: `[${element.wound.isOpen ? 'Open' : 'Closed'}] ${moment(element.wound.evaluationDate).format('MM/DD/YYYY')} - ${!!element.wound.orientationLeftRightName ? `${element.wound.orientationLeftRightName} - ` : ''}${element.wound.bodyRegion ? element.wound.bodyRegion : ''}${element.wound.bodyRegion && element.residentWoundLocation ? '/' : ''}${element.residentWoundLocation ? element.residentWoundLocation : ''}` }
            )).sort((a, b) => a.label.localeCompare(b.label));
            this.setState({ residentWoundList: residentWoundList })
          }
        }).catch((error) => {
          console.log(error)
          showSuccessAlertAutoClose('Sorry, an error has occurred.', 'warning', 'warning!', 3000)
          LogError(error, "ResidentWound", "Get");
        });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();

    let obj = this.state.wound;
    this.setState({ facilityForPDFName: this.state.facilitySelect.label });

    getRequestQry(Uri_GetWoundDocumentationByWoundID, "?woundID=" + obj.woundId)
      .then((res) => {
        if (res.data.statusCode === 200) {
          if (res.data.result != null) {
            let tempObj = this.state.woundEvaluations;
            tempObj.residentName = res.data.result.residentName;
            tempObj.physicianName = res.data.result.physicianName;
            tempObj.woundLocation = res.data.result.woundLocation;
            tempObj.bodyRegionName = res.data.result.bodyRegionName;
            tempObj.skinUlcerTreatmentValues = res.data.result.skinUlcerTreatmentValues;
            tempObj.woundId = this.state.wound.woundId;

            const orientationEnum = {
              LEFT: 2,
              RIGHT: 1,
            }

            const getOrientation = (orientation) => {
              switch (orientation) {
                case orientationEnum.LEFT:
                  return "Left - "
                case orientationEnum.RIGHT:
                  return "Right - "
                default:
                  return ""
              }
            }

            tempObj.orientation = getOrientation(
              res.data.result.woundEvaluationDetail.find(wound => !!wound.orientationLeftRight)?.orientationLeftRight
            );

            tempObj.woundType = res.data.result.woundType;
            tempObj.woundEvaluationDetail = res.data.result.woundEvaluationDetail;
            var evaluationDateArray = [];
            var uvc = 0

            let formattedData = res.data.result.woundEvaluationDetail.sort((a, b) => new Date(a.evaluationDate) - new Date(b.evaluationDate));

            formattedData.forEach(wound => {
              uvc = uvc + 10
              evaluationDateArray.push(
                {
                  name: getInputStringDateUsingMoment2(moment.utc(wound.evaluationDate).local()), uv: uvc
                }
              )
            });

            tempObj.woundType = res.data.result.woundType;
            tempObj.woundEvaluationDetail = res.data.result.woundEvaluationDetail;
            var evaluationDateArray = [];
            var uvc = 0
            res.data.result.woundEvaluationDetail.forEach(wound => {
              uvc = uvc + 10
              evaluationDateArray.push(
                {
                  name: getInputStringDateUsingMoment2(moment.utc(wound.evaluationDate).local()), uv: uvc
                }
              )
            });

            tempObj.woundEvaluationDetail.skinUlcerTreatmentValues = res.data.result.skinUlcerTreatmentValues;

            tempObj.evaluationDateArray = evaluationDateArray;
            this.setState({ woundEvaluations: tempObj, showReport: true })

            console.log(this.state.woundEvaluations)
          } else {
            showSuccessAlert("Record not found", "warning", "warning!", 3000);
            this.setState({ showReport: false })
          }
        }
      })
      .catch((error) => {
        console.error(error);
        showSuccessAlertAutoClose('Sorry, an error has occurred.', 'warning', 'warning!', 3000)
      })
  }

  handleClearFilters = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      facilitySelect: null,
      residentSelect: null,
      woundSelected: null,
      facilityResidentList: [],
      residentWoundList: [],
      showReport: false,
      wound: {
        FacilityId: null,
        ResidentId: null,
        WoundId: null,
      },
      woundEvaluations: {
        residentName: '',
        facilityName: '',
        facilityAddress: '',
        room: '',
        orientation: '',
        physicianName: '',
        woundLocation: '',
        bodyRegionName: '',
        woundType: '',
        acquisition: '',
        woundEvaluationDetail: []
      }
    })

  }

  renderWoundForm() {
    return (
      <>{
        (this.state.IsLoading) ?
          <form onSubmit={e => this.handleSubmit(e)}>
            <div className='row'>
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="FacilityName">Facility Name</label>
                  <Select
                    options={this.state.facilityList}
                    id="facilityId"
                    name="facilityId"
                    required
                    isSearchable
                    isClearable
                    filterOption={createFilter({ matchFrom: 'start' })}
                    onChange={e => this.onFacilityChange(e)}
                    value={this.state.facilitySelect}
                  />
                </div>
              </div>
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="PatientName">Resident Name</label>
                  <Select
                    options={this.state.facilityResidentList}
                    id="residentId"
                    name="residentId"
                    required
                    isSearchable
                    isClearable
                    filterOption={createFilter({ matchFrom: 'start' })}
                    onChange={e => this.onResidentChange(e)}
                    value={this.state.residentSelect}
                  />
                </div>
              </div>
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="WoundType">Wound </label>
                  <Select
                    options={this.state.residentWoundList}
                    id="woundId"
                    name="woundId"
                    required
                    isSearchable
                    isClearable
                    filterOption={createFilter({ matchFrom: 'start' })}
                    onChange={e => {
                      if (!e) { this.setState({ woundSelected: e }) }
                      else {
                        this.setState({ wound: { ...this.state.wound, woundId: e.value } });
                        this.setState({ woundSelected: e })
                      }
                    }}
                    value={this.state.woundSelected}
                  />
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-end py-3'>
              <Button type='submit' variant="success" className="mr-5 px-10" size="sm">Search Report</Button>
              <button className='btn btn-danger btn-sm' onClick={e => this.handleClearFilters(e)}>Clear filter</button>
            </div>
          </form> :
          <div className="d-flex justify-content-center">
            <Loader
              type="Puff"
              color="#00BFFF"
              height={50}
              width={50}
            />
          </div>
      }
      </>
    );
  }

  render() {
    async function PrintElem(state) {
      let doc = new jsPDF('landscape', 'pt', 'a4', false);

      const elm = document.querySelector('#printit');

      await html2canvas(elm, { scale: 2 }).then(canvasItem => {
        const pixelHeight = 775 * 2;
        for (let i = 0; i <= elm.clientHeight * 2; i += pixelHeight) {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = canvasItem.width;
          canvas.height = pixelHeight;
          ctx.drawImage(canvasItem, 0, i, canvasItem.width, pixelHeight, 0, 0, canvasItem.width, pixelHeight);
          const imgData = canvas.toDataURL('image/png');
          doc.addImage(imgData, 'PNG', 10, 30, 822, 0, undefined, 'FAST');
          if (i + pixelHeight < elm.clientHeight * 2) {
            doc.addPage();
          }
        }
      });

      const pageCount = doc.internal.getNumberOfPages();
      doc.setFont('Poppins', 'normal', 'bold');
      doc.setFontSize(8);
      doc.setTextColor(112, 108, 108);
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i)
        doc.text('Page ' + i + ' of ' + pageCount, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 20);
      }

      doc.save(`${state.facilityForPDFName} - Wound Evaluation Report.pdf`);
    }

    return (
      <>
        <Card>
          <CardHeader className='Text-center' title='Wound Evaluation Report'>
            <CardHeaderToolbar>
              <div className="example-tools">

              </div>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            {this.renderWoundForm()}
            <hr />
            {this.state.showReport && <>
              <div className='row'>
                <div className='col-12'>
                  <button type="button" onClick={() => PrintElem(this.state)} className="mr-3 btn btn-success btn-sm float-right">Print Report</button>
                </div>
              </div>
              <div className='wound-evaluation-report'>
                <div id="printit" className='printDiv wound-evaluation-report_content'>
                  <div className='mt-5'>
                    <h2>{this.state.woundEvaluations.facilityName}</h2>
                    <span>{this.state.woundEvaluations.facilityAddress}</span>
                  </div>
                  <div className='mt-5'>
                    <table className='w-100'>
                      <tbody>
                        <tr>
                          <td colSpan={2}>
                            <span className='font-weight-bolder mr-2'>Resident:</span>
                            <span>{this.state.woundEvaluations.residentName}</span>
                          </td>
                          <td>
                            <span className='font-weight-bolder mr-2'>Room:</span>
                            <span>{this.state.woundEvaluations.room}</span>
                          </td>
                          <td>
                            <span className='font-weight-bolder mr-2'>Physician:</span>
                            <span>{this.state.woundEvaluations.physicianName}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='font-weight-bolder mr-2'>Site#:</span>
                            <span>{this.state.woundEvaluations.woundId}</span>
                          </td>
                          <td>
                            <span className='font-weight-bolder mr-2'>Body Region/Location:</span>
                            <span>{this.state.woundEvaluations.orientation}{(this.state.woundEvaluations.bodyRegionName != null && this.state.woundEvaluations.bodyRegionName != "" ? this.state.woundEvaluations.bodyRegionName + " / " : "") + this.state.woundEvaluations.woundLocation}</span>
                          </td>
                          <td>
                            <span className='font-weight-bolder mr-2'>Type of Wound:</span>
                            <span>{this.state.woundEvaluations.woundType}</span>
                          </td>
                          <td>
                            <span className='font-weight-bolder mr-2'>Acquistion:</span>
                            <span>{this.state.woundEvaluations.acquisition}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className='mt-5'>
                    <table className='table table-striped table-sm w-100'>
                      <thead className='thead_style_cust'>
                        <tr>
                          <th width="10%" style={{ borderBottom: "1px solid black", backgroundColor: '#fff' }}></th>
                          <th width="14%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px' }}>Measurements <span>(cm)</span></th>
                          <th width="12%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px' }}>Exudate</th>
                          <th width="12%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px' }}>Wound Bed</th>
                          <th width="12%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px' }}>Periwound</th>
                          <th width="40%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px' }}>Comments</th>
                        </tr>
                      </thead>
                      <tbody className='body_style_cust'>
                        {this.state.woundEvaluations.woundEvaluationDetail?.map((wound) => {
                          return (
                            <tr key={uuid()} style={{ border: "1px solid black" }}>
                              <td>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Date:</span> {getInputStringDateUsingMoment2(
                                    moment(wound.evaluationDate))}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Thickness/</span> </p>
                                  <p className='mb-0'><span className='font-weight-bolder'>Stage:</span> {wound.woundThicknessName}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Tissue type:</span> {wound.woundSevereTissueName}</p>
                                </div>
                              </td>
                              <td>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>L</span> {wound.woundLength} <span className='font-weight-bolder'>W</span> {wound.woundWidth} <span className='font-weight-bolder'>D</span> {wound.woundDepth}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Tunneling:</span>{wound.tunneling ? "Yes" : "No"} </p>
                                  <p className='mb-0'><span className='font-weight-bolder'>Depth:</span>{wound.tunnelingDepth}</p>
                                  <p className='mb-0'><span className='font-weight-bolder'>Clock position:</span> {wound.tunnelingClockPosition}</p>
                                </div>
                                {wound.undermining &&
                                  <div className='border_bottom_cus py-2'>
                                    <p className='mb-0'><span className='font-weight-bolder'>Undermining:</span> {wound.undermining ? "Yes" : "No"}</p>
                                    <p className='mb-0'><span className='font-weight-bolder'>Depth:</span> {wound.underminingDepth}</p>
                                    <p className='mb-0'><span className='font-weight-bolder'>From Clock position:</span> {wound.underminingClockPosition}</p>
                                    <p className='mb-0'><span className='font-weight-bolder'>To Clock position:</span> {wound.toUnderminingClockPosition}</p>
                                  </div>
                                }
                              </td>
                              <td>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Color:</span> {wound.exudateColor}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Exudate Type:</span> {wound.exudateTypeName}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Debridement:</span> {wound.debridementTypeName}</p>
                                  <p className='mb-0'><span className='font-weight-bolder'>Last Debridement Date:</span> {wound.debridementDate != null ? getInputStringDateUsingMoment2(moment(wound.debridementDate)) : "N/A"}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Amount:</span> {wound.exudateAmountName}</p>
                                </div>
                              </td>
                              <td>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Odor:</span>{wound.odor ? "Yes" : "No"}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Pain:</span>{wound.pain ? "Yes" : "No"} </p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Pain Medication ordered:</span> {wound.painMedicationOrdered ? "Yes" : "No"}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Push Score: </span>
                                  {calculatePushScore(wound.woundLength * wound.woundWidth, wound.amount, wound.fkWoundSevereTissueTypeId)}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Wound Bed Description:</span></p>
                                  {wound.granulationPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Granulation %:</span>{wound.granulationPerc} </p>}
                                  {wound.hyperGranulationPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>HyperGranulation %:</span>
                                    {wound.hyperGranulationPerc} </p>}
                                  {wound.sloughPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Slough %:</span>{wound.sloughPerc} </p>}
                                  {wound.necroticPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Necrotic/Eschar %:</span>{wound.necroticPerc} </p>}
                                  {wound.epithelialPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Epithelial %:</span>{wound.epithelialPerc} </p>}
                                  {wound.musclePerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Muscle, Tendon or Bone %:</span>{wound.musclePerc} </p>}
                                  {wound.otherPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>{wound.otherWoundDesc || wound.otherPerc} %:</span>{wound.otherPerc} </p>}
                                </div>
                              </td>
                              <td>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Wound Edges:</span> {wound.woundEdgesName}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Surrounding Skin:</span> {wound.wounSurroundingSkinName}</p>
                                  {wound.wounSurroundingSkinName === "Other" &&
                                    <p className='mb-0'><span className='font-weight-bolder'>Surrounding Skin Other:</span> {wound.otherSurroundingSkin}</p>
                                  }
                                </div>

                              </td>
                              <td>
                                <div className='border_bottom_cus py-2'>
                                <p className='mb-0'><span className='font-weight-bolder'>Skin & Ulcer treatment:</span> {this.state.woundEvaluations?.skinUlcerTreatmentValues?.join("- ")}</p>
                                  <p className='mb-0'><span className='font-weight-bolder'>Treatment:</span> {wound.treatment} </p>
                                  <p className='mb-0'><span className='font-weight-bolder'>General Comments:</span>{wound.comments}</p>
                                </div>
                                <div className='border_bottom_cus py-2'>
                                  <p className='mb-0'><span className='font-weight-bolder'>Signature:</span> {wound.evaluatedBy}</p>
                                  <p className='mb-0'>[E-signed] {moment(wound.evaluationDate).format('MM/DD/YYYY hh:mm A')}</p>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
            }
          </CardBody>
        </Card>

      </>
    );
  }
}